import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

interface UploadProgressSectionProps {
  isUploading: boolean;
  uploadProgress: number;
}

export const UploadProgressSection: React.FC<UploadProgressSectionProps> = ({
  isUploading,
  uploadProgress,
}) => {
  if (!isUploading) return null;

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1, color: '#64748b' }}>
        Uploading documents...
      </Typography>
      <LinearProgress
        variant="determinate"
        value={uploadProgress}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: '#e2e8f0',
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
            backgroundColor: '#3b82f6',
          },
        }}
      />
      <Typography variant="caption" sx={{ color: '#64748b', mt: 1, display: 'block' }}>
        {Math.round(uploadProgress)}% complete
      </Typography>
    </Box>
  );
};

export default UploadProgressSection;
